var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43719 0.901782C6.5841 1.05216 6.66663 1.2561 6.66663 1.46874C6.66663 1.68137 6.5841 1.88531 6.43719 2.03569L2.55817 6.00517L6.43719 9.97464C6.57993 10.1259 6.65892 10.3285 6.65713 10.5387C6.65535 10.749 6.57293 10.9501 6.42764 11.0988C6.28235 11.2475 6.0858 11.3318 5.88033 11.3336C5.67486 11.3355 5.47692 11.2546 5.32912 11.1086L0.896064 6.57212C0.749154 6.42174 0.666625 6.21781 0.666625 6.00517C0.666625 5.79253 0.749154 5.58859 0.896064 5.43821L5.32912 0.901782C5.47607 0.751446 5.67536 0.666992 5.88315 0.666992C6.09095 0.666992 6.29023 0.751446 6.43719 0.901782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.47074c4558111e9cc23545665c88c5f1.svg";
export { ForwardRef as ReactComponent };